export const waitForElementToRender = (selector: string) => {
    return new Promise(resolve => {
        // If it's already in DOM, resolve immediately
        if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
        }
        // Add an observer to resolve this Promise when the selector is found in the DOM
        const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
            observer.disconnect();
            resolve(document.querySelector(selector));
        }
        });
        observer.observe(document.documentElement, {
        childList: true,
        subtree: true
        });
    });
}

export const handleOverlappingElements = (hide: boolean) => {
  // Medallia Feedback button
  waitForElementToRender('#kampyleButtonContainer').then((ele: HTMLElement) => {
    if (ele) {
      ele.style.display = hide ? 'none' : '';
    }
  });
  // Zendesk Chat button
  waitForElementToRender('#launcher').then((ele: HTMLElement) => {
    if (ele) {
      ele.style.display = hide ? 'none' : '';
    }
  });
}